// removed by extract-text-webpack-plugin
module.exports = {"PopupHeader":"_2IJqjJkoJJPeJ5iLzWaQN5","PopupBox":"_3Rg80-nifbMKvPdKpYf0Br","PopupBox--error":"HqkOcUrsfD_KsBerYpu5u","jiggle":"_3Q38qTZR2xGH-BY0HEE64m","PopupBox__inner":"_1aPeV8EEbNbAPXAAt7yUMP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PopupBoxWithBackground/PopupBoxWithBackground.scss
// module id = 1239
// module chunks = 0